import { useAzureAuth } from "@datamole/wds-azure-auth";

import { MicrosoftIcon } from "@/components/ui/Icons";
import { Button } from "@/components/ui/buttons/Button";
import styles from "@/pages/LoginPage/MicrosoftLoginButton/MicrosoftLoginButton.module.css";

export const MicrosoftLoginButton = () => {
    const { triggerLogin } = useAzureAuth();

    const handleLogin = async () => {
        // TODO: add scopes when supported by wds-azure-auth: { scopes: [config.AZURE_AUTH_SCOPE], },
        triggerLogin();
    };

    return (
        <Button className={styles.button} size="lg" startIcon={<MicrosoftIcon />} onClick={handleLogin}>
            Log in with Microsoft Entra ID
        </Button>
    );
};
